// eslint-disable-next-line no-unused-vars
import i18n from '@/libs/i18n'
import { hasPrePreviewAccess } from '@/utils/prePreviewAccess'

// Route guard to check Pre-Preview access
const checkPrePreviewAccess = (to, from, next) => {
  if (hasPrePreviewAccess()) {
    next()
  } else {
    // Redirect to dashboard if user doesn't have access
    next({ name: 'dashboard' })
  }
}

export default [
  {
    path: '/pre-preview',
    name: 'pre-preview',
    component: () => import('@/views/pre-preview/Index.vue'),
    beforeEnter: checkPrePreviewAccess,
    meta: {
      pageTitle: 'Pre-Preview',
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'dashboard' },
        },
        {
          text: 'Pre-Preview',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pre-preview/upload',
    name: 'pre-preview-upload',
    component: () => import('@/views/pre-preview/Upload.vue'),
    beforeEnter: checkPrePreviewAccess,
    meta: {
      pageTitle: 'Upload Creative - Pre-Preview',
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'dashboard' },
        },
        {
          text: 'Pre-Preview',
          to: { name: 'pre-preview' },
        },
        {
          text: 'Upload Creative',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pre-preview/creatives',
    name: 'pre-preview-creatives',
    component: () => import('@/views/pre-preview/Creatives.vue'),
    beforeEnter: checkPrePreviewAccess,
    meta: {
      pageTitle: 'Creative Library - Pre-Preview',
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'dashboard' },
        },
        {
          text: 'Pre-Preview',
          to: { name: 'pre-preview' },
        },
        {
          text: 'Creative Library',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pre-preview/tasks',
    name: 'pre-preview-tasks',
    component: () => import('@/views/pre-preview/TaskLog.vue'),
    beforeEnter: checkPrePreviewAccess,
    meta: {
      pageTitle: 'Task Log - Pre-Preview',
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'dashboard' },
        },
        {
          text: 'Pre-Preview',
          to: { name: 'pre-preview' },
        },
        {
          text: 'Task Log',
          active: true,
        },
      ],
    },
  },
]
